// Helper Functions
window.eventStreaming = window.eventStreaming || {};

window.eventStreaming.getPageType = (url) => {
  if (!url) {
    return "";
  }
  const urlWithoutQuery = url.split("?")[0];
  const isRoot = /^https?:\/\/[^\/]+\/?$/.test(urlWithoutQuery);

  if (isRoot) {
    return "homepage";
  } else if (/\/products\//.test(url)) {
    return "product page";
  } else if (/\/collections\//.test(url)) {
    return "collection page";
  } else {
    return "other";
  }
};

window.onload = async function () {
  async function updateCartAttributes(deviceId) {
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            deviceId: deviceId,
            appVersion: localStorage.getItem("appVersion") ?? "NA",
            webOrigin: localStorage.getItem("isApp")
              ? "CUREFIT_APP"
              : "CULTSTORE_WEBSITE",
          },
        }),
      });

      if (!response.ok) {
        throw new Error(
          `Error updating cart attributes: ${response.statusText}`,
        );
      }

      const cartData = await response.json();
      console.log("Cart updated successfully:", cartData);
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  }

  function flattenCart(cart) {
    let flattened = {
      token: cart.token,
      note: cart.note,
      originalTotalPrice: cart.original_total_price,
      totalPrice: cart.total_price,
      totalDiscount: cart.total_discount,
      totalWeight: cart.total_weight,
      itemCount: cart.item_count,
      requiresShipping: cart.requires_shipping,
      currency: cart.currency,
      itemsSubtotalPrice: cart.items_subtotal_price,
    };

    // Flatten attributes
    if (cart.attributes) {
      Object.keys(cart.attributes).forEach((key) => {
        flattened[`attribute_${key}`] = cart.attributes[key];
      });
    }

    // Flatten cart-level discounts
    flattened.cartLevelDiscounts =
      cart.cart_level_discount_applications.length > 0
        ? cart.cart_level_discount_applications
            .map((d, i) => `${i}: ${JSON.stringify(d)}`)
            .join(", ")
        : "None";

    // Flatten items
    let productTitles = [],
      productPrices = [],
      productIds = [],
      productUrls = [],
      productTypes = [],
      variantTitles = [],
      skus = [],
      quantities = [],
      images = [],
      vendors = [];

    cart.items.forEach((item, index) => {
      productTitles.push(`${index}: ${item.product_title}`);
      productPrices.push(`${index}: ${item.price}`);
      productIds.push(`${index}: ${item.product_id}`);
      productUrls.push(`${index}: ${item.url}`);
      productTypes.push(`${index}: ${item.product_type}`);
      variantTitles.push(`${index}: ${item.variant_title}`);
      skus.push(`${index}: ${item.sku}`);
      quantities.push(`${index}: ${item.quantity}`);
      images.push(`${index}: ${item.image}`);
      vendors.push(`${index}: ${item.vendor}`);
    });

    flattened.productTitles = productTitles.join(", ");
    flattened.productPrices = productPrices.join(", ");
    flattened.productIds = productIds.join(", ");
    flattened.productUrls = productUrls.join(", ");
    flattened.productTypes = productTypes.join(", ");
    flattened.variantTitles = variantTitles.join(", ");
    flattened.skus = skus.join(", ");
    flattened.quantities = quantities.join(", ");
    flattened.images = images.join(", ");
    flattened.vendors = vendors.join(", ");

    return flattened;
  }

  updateCartAttributes(getCookieValue("_shopify_y"));

  // Helper function to dispatch custom events
  window.eventStreaming.dispatchCustomEvent = (eventName, data) => {
    console.log("Event: ", eventName, data);
    const event = new CustomEvent(eventName, {
      detail: data,
      bubbles: true,
      cancelable: true,
    });
    // eventName == "ATC" && branch.logEvent(
    //     'branch_atc',
    //     data,
    //     function(err) { console.log(err); }
    // );
    document.dispatchEvent(event);
  };

  function getCookieValue(cookieName) {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
      const [name, value] = cookie.split("=");
      if (name === cookieName) {
        return decodeURIComponent(value);
      }
    }
    return null; // Return null if the cookie is not found
  }

  // If utm_parameters are present in the URL, get them and return
  function getUtmParameters() {
    const params = new URLSearchParams(window.location.search);
    const utmParams = {};
    for (const [key, value] of params.entries()) {
      if (key.includes("utm_")) {
        utmParams[key] = value;
      }
    }
    return utmParams;
  }

  // User Attibutes - USER_ATTRIBUTES if logged in
  if (localStorage.getItem("customer")) {
    const customerData = JSON.parse(localStorage.getItem("customer"));
    window.eventStreaming.dispatchCustomEvent("USER_ATTRIBUTES", customerData);
  }

  //Helper Functions
  // Prepare Common Details
  window.eventStreaming.prepareCommonDetails = () => {
    try {
      const metaData = window.eventStreaming.metaData;
      let commonFields = {
        ...metaData,
        pageUrl: window.location.href,
        utmParams: getUtmParameters(),
        previousPageUrl: document.referrer,
        screenHeight: window.screen.height,
        screenWidth: window.screen.width,
        webOrigin: localStorage.getItem("isApp")
          ? "CUREFIT_APP"
          : "CULTSTORE_WEBSITE",
        userAgent: navigator.userAgent,
        appVersion: localStorage.getItem("appVersion") ?? "",
        eventId: crypto.randomUUID() + "-" + crypto.randomUUID(),
        deviceId: getCookieValue("_shopify_y"),
        redirectDeviceId:
          localStorage.getItem("1p_redirect_id") ||
          new URLSearchParams(window.location.search).get("utm_redirect_id") ||
          "",
        sessionId: getCookieValue("_shopify_s"),
        previousPageCategory: window.eventStreaming.getPageType(
          document.referrer,
        ),
        pageCategory: window.eventStreaming.getPageType(window.location.href),
      };
      // #TODO: Implement session id later
      // gtag('get', 'G-ZWHZKTYB0D', 'session_id', (id) => {
      //     commonFields.sessionId = id
      // });
      return commonFields;
    } catch (err) {
      console.error(err);
      return err;
    }
  };

  //Fire On Page Load Events
  //Page View - PAGE_VIEW
  if (window.location.href.includes("products")) {
    // Fetch product details from the product page
    const customData = await window.eventStreaming.prepareCommonDetails();
    const data = await window.customProductData.product;
    customData["product"] = data;
    if (data && typeof data === "object") {
      Object.keys(data).forEach((key) => {
        customData["pd_" + key] = data[key];
      });
    }
    customData["productHandle"] = data.handle;
    customData["productId"] = data.id;
    customData["csProductId"] = window.customProductData?.productCsId;
    customData["productTitle"] = data.title;
    customData["productFirstImage"] = data.image?.src;
    customData["productSellingPrice"] = data.variants[0]?.price;
    customData["productMrp"] = data.variants[0]?.compare_at_price;

    // Probing for cases where previous page is from cultsport.com and customData does not have redirect_id
    if (
      !customData.redirectDeviceId &&
      document.referrer &&
      new URL(document.referrer).hostname.includes("cultsport.com")
    ) {
      console.error("Redirect Device ID not found, setting it to empty string");
    }

    window.eventStreaming.dispatchCustomEvent("PAGE_VIEW", customData);
  } else {
    // Fetch common details from the page
    const customData = await window.eventStreaming.prepareCommonDetails();
    window.eventStreaming.dispatchCustomEvent("PAGE_VIEW", customData);
  }

  //Button Click - BUTTON_CLICK
  document.querySelectorAll("button").forEach((button) => {
    button.addEventListener("click", async (e) => {
      const customData = await window.eventStreaming.prepareCommonDetails();
      customData["buttonName"] = e.target.getAttribute("data-event-name");
      customData["buttonAction"] = e.target.getAttribute("data-event-type");
      window.eventStreaming.dispatchCustomEvent("BUTTON_CLICK", customData);
    });
  });

  //Link Click - LINK_CLICK
  document.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", async (e) => {
      const customData = await window.eventStreaming.prepareCommonDetails();
      customData["linkName"] = e.target.getAttribute("data-event-name");
      customData["linkAction"] = e.target.getAttribute("data-event-type");
      window.eventStreaming.dispatchCustomEvent("LINK_CLICK", customData);
    });
  });

  //Apply Sort - APPLY_SORT
  async function handleSortChange() {
    let stateChanged = false;
    if (window.location.search.includes("sort_by=")) {
      const sortName = new URLSearchParams(window.location.search).get(
        "sort_by",
      );
      if (sortName !== previousState.sort) {
        customData["sortName"] = sortName;
        previousState.sort = sortName;
        stateChanged = true;
      }
    }

    if (stateChanged) {
      window.eventStreaming.dispatchCustomEvent("APPLY_SORT", customData);
    }
  }

  //Apply Filter - APPLY_FILTER, Apply Sort - APPLY_SORT
  // Function to parse URL parameters and filter those containing 'filter'
  function getFilterParams() {
    const params = new URLSearchParams(window.location.search);
    const filters = {};
    for (const [key, value] of params.entries()) {
      if (key.includes("filter")) {
        filters[key] = value;
      }
    }
    return filters;
  }

  // Function to handle filter and sort logic
  let previousState = {
    filters: null,
    sort: null,
  };

  async function handleFilterAndSortChange() {
    const customData = await window.eventStreaming.prepareCommonDetails();
    let filterStateChanged = false;
    let sortStateChanged = false;

    // Handle filters
    if (window.location.href.includes("filter")) {
      const filterParams = getFilterParams();
      if (
        JSON.stringify(filterParams) !== JSON.stringify(previousState.filters)
      ) {
        customData["appliedFilters"] = filterParams;
        customData["sortName"] = previousState.sort;
        previousState.filters = filterParams;
        filterStateChanged = true;
      }
    }

    // Handle sort
    if (window.location.search.includes("sort_by=")) {
      const sortName = new URLSearchParams(window.location.search).get(
        "sort_by",
      );
      if (sortName !== previousState.sort) {
        customData["appliedFilters"] = getFilterParams();
        customData["sortName"] = sortName;
        previousState.sort = sortName;
        sortStateChanged = true;
      }
    }

    if (filterStateChanged) {
      window.eventStreaming.dispatchCustomEvent("APPLY_FILTER", customData);
    }

    if (sortStateChanged) {
      window.eventStreaming.dispatchCustomEvent("APPLY_SORT", customData);
    }
  }

  // Listen for popstate event to handle browser navigation
  window.addEventListener("popstate", handleFilterAndSortChange);

  // MutationObserver to detect changes to the URL query parameters
  const observer = new MutationObserver(() => {
    handleFilterAndSortChange();
  });

  // Observe changes to the URL
  observer.observe(document, { subtree: true, childList: true });

  // Initial call to handle filter and sort logic on page load
  handleFilterAndSortChange();

  //Variant Selected - VARIANT_SELECTED
  document.addEventListener("on:variant:change", async (e) => {
    const customData = await window.eventStreaming.prepareCommonDetails();
    const product = await window.customProductData.product;
    customData["product"] = product;
    if (product && typeof product === "object") {
      Object.keys(product).forEach((key) => {
        customData["pd_" + key] = product[key];
      });
    }
    customData["selectedVariant"] =
      await window.customProductData.selectedVariant;
    customData["variant"] = e.detail.variant;
    customData["selectedOptions"] = e.detail.selectedOptions;
    customData["selectedQuantity"] = parseInt(
      document.getElementById("quantity")?.value || 1,
    );
    customData["availableOfferIds"] = await window.allOffers.pdpOffers.map(
      (offer) => offer.offerId,
    );
    window.eventStreaming.dispatchCustomEvent("VARIANT_SELECTED", customData);
  });

  // //Add To Cart - ATC
  // document.querySelectorAll('.add-to-cart').forEach((button) => {
  //     button.addEventListener('click', async (e) => {
  //         const customData = await window.eventStreaming.prepareCommonDetails();
  //         customData['product'] = await window.customProductData.product; // need to implement another helper function to get product from liquid file
  //         customData['selectedOptions'] = e.detail.selectedOptions;
  //         customData['selectedQuantity'] = parseInt(document.getElementById('quantity').value);
  //         customData['availableOfferIds'] = await window.allOffers.pdpOffers.map((offer) => offer.offerId);
  //         window.eventStreaming.dispatchCustomEvent('ATC', customData);
  //     })
  // });

  //Cart Open - CART_OPEN
  document.addEventListener("on:cart-drawer:after-open", async (e) => {
    const customData = await window.eventStreaming.prepareCommonDetails();
    try {
      const cart = await fetch("/cart.js").then((response) => response.json());
      customData["cart"] = cart;
      let cartObject = flattenCart(cart);
      if (cartObject && typeof cartObject === "object") {
        Object.keys(cartObject).forEach((key) => {
          customData["cart_" + key] = cartObject[key];
        });
      }
      customData["cartTotal"] = cart.total_price;
      customData["availableOfferIds"] = await window.allOffers.pdpOffers.map(
        (offer) => offer.offerId,
      );
      window.eventStreaming.dispatchCustomEvent("CART_OPEN", customData);
    } catch (error) {
      console.error("Data pipeline broken as cart.js fetch failed", error);
    }
  });

  //Cart Close - CART_CLOSE
  document.addEventListener("on:cart-drawer:after-close", async (e) => {
    const customData = await window.eventStreaming.prepareCommonDetails();
    try {
      const cart = await fetch("/cart.js").then((response) => response.json());
      customData["cart"] = cart;
      let cartObject = flattenCart(cart);
      if (cartObject && typeof cartObject === "object") {
        Object.keys(cartObject).forEach((key) => {
          customData["cart_" + key] = cartObject[key];
        });
      }
      customData["cartTotal"] = cart.total_price;
      customData["availableOfferIds"] = await window.allOffers.pdpOffers.map(
        (offer) => offer.offerId,
      );
      window.eventStreaming.dispatchCustomEvent("CART_CLOSE", customData);
    } catch (error) {
      console.error("Data pipeline broken as cart.js fetch failed", error);
    }
  });

  //Cart Update - CART_UPDATE
  window.addEventListener("cart_changed", async (e) => {
    const customData = await window.eventStreaming.prepareCommonDetails();
    try {
      const cart = await fetch("/cart.js").then((response) => response.json());
      customData["cart"] = cart;
      let cartObject = flattenCart(cart);
      if (cartObject && typeof cartObject === "object") {
        Object.keys(cartObject).forEach((key) => {
          customData["cart_" + key] = cartObject[key];
        });
      }
      customData["itemsRemoved"] = e.detail.removed;
      customData["itemsAdded"] = e.detail.added;
      customData["cartTotal"] = cart.total_price;
      customData["availableOfferIds"] = await window.allOffers.pdpOffers.map(
        (offer) => offer.offerId,
      );
      window.eventStreaming.dispatchCustomEvent("CART_UPDATE", customData);

      // Check if items were added to the cart
      if (customData["itemsAdded"] && customData["itemsAdded"].length > 0) {
        const product = await window.customProductData.product;
        customData["product"] = product;
        const productCsId = window.customProductData.productCsId;
        customData["productCsId"] = productCsId;
        if (product && typeof product === "object") {
          Object.keys(product).forEach((key) => {
            customData["pd_" + key] = product[key];
          });
        }
        customData["selectedVariant"] =
          await window.customProductData.selectedVariant;
        customData["selectedOptions"] = e.detail.selectedOptions;
        customData["selectedQuantity"] = parseInt(
          document.getElementById("quantity")?.value || 1,
        );
        window.eventStreaming.dispatchCustomEvent("ATC", customData);
      }
    } catch (error) {
      console.error("Data pipeline broken as cart.js fetch failed", error);
    }
  });

  //Checkout Clicked - CHECKOUT_CLICKED
  document.querySelectorAll("marmeto-checkout-button").forEach((button) => {
    button.addEventListener("click", async (e) => {
      const customData = await window.eventStreaming.prepareCommonDetails();
      try {
        const cart = await fetch("/cart.js").then((response) =>
          response.json(),
        );
        customData["cart"] = cart;
        let cartObject = flattenCart(cart);
        if (cartObject && typeof cartObject === "object") {
          Object.keys(cartObject).forEach((key) => {
            customData["cart_" + key] = cartObject[key];
          });
        }
        customData["cartTotal"] = cart.total_price;
        customData["availableOfferIds"] = await window.allOffers.pdpOffers.map(
          (offer) => offer.offerId,
        );
        window.eventStreaming.dispatchCustomEvent(
          "CHECKOUT_CLICKED",
          customData,
        );
      } catch (error) {
        console.error("Data pipeline broken as cart.js fetch failed", error);
      }
    });
  });

  //Login Initiated - LOGIN_INITIATED
  document.addEventListener("event:login:init", async (e) => {
    const customData = await window.eventStreaming.prepareCommonDetails();
    window.eventStreaming.dispatchCustomEvent("LOGIN_INITIATED", customData);
  });

  //Login Started - LOGIN_STARTED
  document.addEventListener("event:login:start", async (e) => {
    const customData = await window.eventStreaming.prepareCommonDetails();
    customData["loginMethod"] = e.detail.method;
    switch (e.detail.method) {
      case "email":
        customData["email"] = e.detail.email;
        break;
      case "phone":
        customData["phone"] = e.detail.phone;
        break;
      case "google":
        customData["google"] = e.detail.google;
        break;
      case "facebook":
        customData["facebook"] = e.detail.facebook;
        break;
      case "apple":
        customData["apple"] = e.detail.apple;
        break;
      case "truecaller":
        customData["phone"] = e.detail.truecaller;
        break;
      default:
        break;
    }
    window.eventStreaming.dispatchCustomEvent("LOGIN_STARTED", customData);
  });

  //OTP Submitted - OTP_SUBMITTED
  document.addEventListener("event:login:otp", async (e) => {
    const customData = await window.eventStreaming.prepareCommonDetails();
    customData["method"] = e.detail.method;
    customData["phone"] = e.detail.phone;
    customData["otpVerified"] = e.detail.otpVerified;
    window.eventStreaming.dispatchCustomEvent("OTP_SUBMITTED", customData);
  });

  //Login Completed - LOGIN_COMPLETED
  document.addEventListener("event:login:complete", async (e) => {
    const customData = await window.eventStreaming.prepareCommonDetails();
    window.eventStreaming.dispatchCustomEvent("LOGIN_COMPLETED", customData);
  });

  //Search - SEARCH
  document.addEventListener("on:search", async (e) => {
    const customData = await window.eventStreaming.prepareCommonDetails();
    customData["search"] = e.detail;
    window.eventStreaming.dispatchCustomEvent("SEARCH", customData);
  });

  // CHECKOUT PROCESS
  document.addEventListener("CHECKOUT_PROCESS_INTERNAL", async (e) => {
    const customData = await window.eventStreaming.prepareCommonDetails();
    try {
      const cart = await fetch("/cart.js").then((response) => response.json());
      customData["cart"] = cart;
      let cartObject = flattenCart(cart);
      if (cartObject && typeof cartObject === "object") {
        Object.keys(cartObject).forEach((key) => {
          customData["cart_" + key] = cartObject[key];
        });
      }
      customData["juspayRequestId"] = e.detail.requestId;
      switch (e.detail.event) {
        case "AddPaymentInfo":
          customData["checkoutEvent"] = "ADD_PAYMENT_INFO";
          break;
        case "AddedAddress":
          customData["checkoutEvent"] = "ADD_ADDRESS";
          break;
        case "UpdatedAddress":
          customData["checkoutEvent"] = "UPDATE_ADDRESS";
          break;
        // case 'Purchase':
        //     customData['checkoutEvent'] = 'ORDER';
        //     customData['shopOrderId'] = e.detail.data.shopOrderId;
        //     customData['totalPrice'] = e.detail.data.totalPrice;
        //     customData['itemCount'] = e.detail.data.itemCount;
        //     customData['items'] = e.detail.data.items;
        //     break;
        case "OrderComplete":
          customData["checkoutEvent"] = "CHECKOUT_COMPLETE";
          break;
        default:
          customData["checkoutEvent"] = e.detail.event;
          customData["otherDetails"] = e.detail.data;
          break;
      }
      window.eventStreaming.dispatchCustomEvent("CHECKOUT_PROCESS", customData);
    } catch (error) {
      console.error("Data pipeline broken as cart.js fetch failed", error);
    }
  });

  //Native Checkout Process Events for App
  window.addEventListener("message", (e) => {
    if (typeof e.data === "string" && e.data?.includes("nativeCheckout")) {
      let { data } = JSON.parse(e.data);
      const { requestId, payload } = data;
      const { action, event } = payload;
      if (action === "startCheckout") {
        if (event === "Purchase") {
          let { data } = payload;
          const customEvent = new CustomEvent("CHECKOUT_PROCESS_INTERNAL", {
            detail: { requestId, event, data },
          });
          document.dispatchEvent(customEvent);
        } else {
          const customEvent = new CustomEvent("CHECKOUT_PROCESS_INTERNAL", {
            detail: { requestId, event },
          });
          document.dispatchEvent(customEvent);
        }
      }
    }
  });
};
